export const FORM_SELECTOR = '.frame.frame-type-form_formframework form'
export const JUST_VALIDATE_DATA_SELECTOR = '.just-validate-data'
export const JUST_VALIDATE_CONFIG_SELECTOR = '.just-validate-config'
export const JUST_VALIDATE_GLOBAL_CONFIG_SELECTOR = '.just-validate-global-config'
export const FORM_VALIDATOR_SETUP_EVENT = 'formvalidator-setup'
export const FORM_VALIDATOR_EVENT_BASE = 'formvalidator-on'
export const FORM_VALIDATOR_EVENT_VALIDATION = 'formvalidator-onValidation'
export const FORM_VALIDATOR_EVENT_ALL_OK = 'formvalidator-allOk'
export const FORM_VALIDATOR_EVENT_KO = 'formvalidator-ko'

export const DEFAULT_JUST_VALIDATE_EVENT: keyof HTMLElementEventMap = 'blur'

export const GOOGLE_VERIFY_URL = 'https://www.google.com/recaptcha/api/siteverify'
